/* ============================================================================
   PDP shipping copy — purchase-type sync.

   The Shipping & Guarantee block renders both shipping lines (one-time and subscription) and
   main-product.liquid hides the one that doesn't match the plan picker's initial state. Only
   Skio knows what the shopper picks after that, so we mirror its `skio::update-selling-plan`
   event onto the block. `detail.sellingPlan` is empty for a one-time purchase, and the event
   also fires on plan-to-plan changes, which keep the subscription line in place.

   The event bubbles and is composed, so one document listener covers every picker on the page
   (main PDP + quick-buy modal); the scope lookup keeps a modal from rewriting the PDP behind it.
   ============================================================================ */
(function () {
  // The block snippet enqueues this script, so it can appear more than once on a page
  // (e.g. quick-view modal + main PDP). Subscribe only once.
  if (window.__lsShippingPurchaseTypeInit) return;
  window.__lsShippingPurchaseTypeInit = true;

  document.addEventListener('skio::update-selling-plan', function (event) {
    var picker = event.target;
    if (!picker || !picker.closest) return;

    var scope = picker.closest('product-info') || picker.closest('.shopify-section') || document;
    var purchaseType = event.detail && event.detail.sellingPlan ? 'subscription' : 'one-time';

    scope.querySelectorAll('[data-shipping-text]').forEach(function (line) {
      line.hidden = line.getAttribute('data-shipping-text') !== purchaseType;
    });
  });
})();
